import { Button } from "../components/ui/buttons/Button"
import Logo from "../assets/images/MarTrak.jpg"
import { menuItems } from "layouts/menuOptions";
//context/hooks
import { useSidebar } from "@contexts/SidebarContext";
import { useUser } from "@contexts/UserContext";
import usePermissions from "../hooks/usePermissions";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom"

/**
 * Home page with menu options, which are shown only if users have specific permissions
 * 
 * @returns {JSX.Element}
 * 
 * @category Pages
 */
export const Home = () => {
    const navigate = useNavigate();
    const { hasPermission, isInGroup, isExternal } = usePermissions();
    const{ logout } = useUser()
    const { isMobile } = useSidebar()

    useEffect(() => {
        document.title =  `MarTrak - Home`
    }, []);

    const iconClasses = "mr-2 text-purple-800"

    return(
        <div className="flex justify-center h-full w-full">

            {/* show menu on initial login - on other pages, user can access menu from sidebar */}
       
                <div className="flex flex-col w-56 pt-16 pb-10">

                    {menuItems.map(({ label, icon, path, permission, groups }) => {
                        //if missing required permissions, don't render button
                        if (
                            (permission && !hasPermission(permission.resource, permission.action)) ||
                            (groups && !isInGroup(groups))
                        ) {
                            return null;
                        }

                        return (
                            <Button
                                key={label}
                                variant="noBackground"
                                onClick={() => navigate(path)}
                                className="text-left"
                            >
                            <i className={`fa-solid ${icon} ${iconClasses}`}></i>
                            {label}
                            </Button>
                        );
                    })}

                    <Button
                        key="help-button"
                        variant="noBackground"
                        className="text-left"
                    >
                    
                    {isExternal() ? (
                        <a href="/Martrak-How-To-Guide-Version2-External.pdf" download={true}>
                            <i className={`fa-regular fa-circle-question ${iconClasses}`}></i>
                            Help
                        </a>
                    ) : (
                        <a href="/Martrak-How-To-Guide-Version2.pdf" download={true}>
                            <i className={`fa-regular fa-circle-question ${iconClasses}`}></i>
                            Help
                        </a>
                    )}
                    </Button>

                    {isMobile && (
                        <Button
                            onClick={() => logout()}
                            variant="noBackground"
                            className="text-left"
                        >
                            <i className={`fa-solid fa-right-from-bracket ${iconClasses}`}></i>
                            Log out
                        </Button>
                    )}

                </div>

  
        </div>
    )
}